import { render, staticRenderFns } from "./UserDataSetting.vue?vue&type=template&id=32e168f2"
import script from "./UserDataSetting.vue?vue&type=script&lang=ts"
export * from "./UserDataSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports